import { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { inject, observer, PropTypes as MobXPropTypes } from 'mobx-react';
import queryString from 'query-string';
import Table from 'react-bootstrap/Table';
import { LogsTabHeadRow } from './components/LogsTabHeadRow';
import { LogsTabTableRow } from './components/LogsTabTableRow';
import { MENU_DIRECTION } from 'components/constants';
import i18nContext from 'components/i18n-context';
import Loader from 'components/Loader';
import Pagination from 'components/Pagination/Pagination';
import { formatDateTime } from 'services/utils';
import './LogsTab.scss';

const LogsTab = ({ customerId, customersStore }) => {
  const i18n = useContext(i18nContext);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = queryString.parse(location.search);
    customersStore.setFiltersFromUrl(params);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const currentParams = new URLSearchParams(location.search);
    currentParams.set('page', customersStore.pagination.page.toString());
    currentParams.set('size', customersStore.pagination.size.toString());

    navigate({ search: `?${currentParams.toString()}` }, { replace: true });
    customersStore.loadCustomerLogs(customerId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customersStore.pagination.size, customersStore.pagination.page]);

  const handleSetCurrentPage = (pageNumber) => {
    customersStore.setPageNumber(pageNumber);
  };

  const handleSetPageSize = (size) => {
    customersStore.setPageSize(size);
  };

  if (!customersStore.currentCustomerLogs) {
    return <Loader className={'application-loader logs-tab-loader'} />;
  }

  return (
    <div className={'logs-container'}>
      <table className={'table-wrapper'}>
        <tbody className={'table-body'}>
          <tr className={'table-row'}>
            <td className={'table-cell'}>{i18n.getMessage('customerLogs.firstAccountCreationDate')}</td>
            <td className={'table-cell'}>
              {customersStore?.currentCustomerDetails?.firstWalletCreatedAt
                ? formatDateTime(customersStore.currentCustomerDetails.firstWalletCreatedAt)
                : ''}
            </td>
          </tr>
        </tbody>
      </table>

      <div className={'logs-container-table'}>
        <Pagination
          isLoading={customersStore.isLoadingLogs}
          isShowPaginationSize={true}
          paginationSize={customersStore.pagination.size}
          handleChangePaginationSize={handleSetPageSize}
          currentPage={customersStore.pagination.page}
          numberOfPages={customersStore.pagination.totalPages}
          setCurrentPage={handleSetCurrentPage}
          menuDirection={MENU_DIRECTION.DOWN}
        />

        <Table responsive>
          <thead>
            <LogsTabHeadRow />
          </thead>
          <tbody>
            {customersStore.currentCustomerLogs.map((log, index) => (
              <LogsTabTableRow isLoading={false} logsTabData={log} key={index} />
            ))}
          </tbody>
        </Table>

        <Pagination
          isLoading={customersStore.isLoadingLogs}
          isShowPaginationSize={true}
          paginationSize={customersStore.pagination.size}
          handleChangePaginationSize={handleSetPageSize}
          currentPage={customersStore.pagination.page}
          numberOfPages={customersStore.pagination.totalPages}
          setCurrentPage={handleSetCurrentPage}
          menuDirection={MENU_DIRECTION.DOWN}
        />
      </div>
    </div>
  );
};

LogsTab.propTypes = {
  customerId: PropTypes.string,
  customersStore: MobXPropTypes.observableObject
};

export default inject((stores) => ({
  customersStore: stores.customersStore
}))(observer(LogsTab));
